import { render, staticRenderFns } from "./ListProductionArchiver.vue?vue&type=template&id=96cbcfe6&scoped=true&"
import script from "./ListProductionArchiver.vue?vue&type=script&lang=js&"
export * from "./ListProductionArchiver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96cbcfe6",
  null
  
)

export default component.exports